/* eslint-disable react/prop-types */
import { Box, responsive, tokensRaw } from '@vp/swan';
import { Placeholder } from './Placeholder';

type RequestCardImageProps = {
    imgSrc?: string;
    imgAlt?: string;
};

const ResponsiveBox = responsive(Box);

export const RequestCardImage: React.FC<RequestCardImageProps> = ({ imgSrc, imgAlt }) => {
    return (
        <ResponsiveBox
            xs={{
                style: {
                    maxWidth: '300px',
                    borderRadius: tokensRaw.SwanSemBorderRadiusStrong,
                    flex: '1 1 100%',
                    width: '100%',
                    overflow: 'hidden',
                    padding: 0,
                    backgroundColor: tokensRaw.SwanBaseColorGrey100,
                    display: 'flex',
                },
            }}
            sm={{
                style: { maxWidth: '205px' },
            }}
        >
            {imgSrc ? (
                <img
                    src={imgSrc}
                    alt={imgAlt}
                    style={{
                        width: '100%',
                        height: 'auto',
                        objectFit: 'cover',
                        display: 'block',
                    }}
                />
            ) : (
                <Box padding="2">
                    <Placeholder />
                </Box>
            )}
        </ResponsiveBox>
    );
};
